import React from 'react';

import {BackendJob, HygienistBackendJob} from "components/EditJob";
import JobListItem from './JobListItem';
import HygienistJobListItem from './HygienistJobListItem';

import {
    Container,
} from './JobList.styles'

interface JobListProps {
    jobs: BackendJob[] | HygienistBackendJob[],
    isHygienist?: boolean,
    onJobClick: (job: BackendJob | HygienistBackendJob) => void,
    isActive?: boolean
}

const JobList = ({ jobs, onJobClick, isHygienist = false, isActive }: JobListProps) => {
    return (
        <Container>
            {jobs.map((job) => (
                isHygienist ?
                    <HygienistJobListItem key={job.id} job={job as HygienistBackendJob} onJobClick={onJobClick} /> :
                    <JobListItem key={job.id} job={job as BackendJob} onJobClick={onJobClick} isActive={isActive}/>
            ))}
        </Container>
    )
}

export default JobList;
